module.exports = __webpack_public_path__ + "img/logoZonaR.e22c3a09.png";